import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useImportantInformationMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["important-information-masterdata"],
    queryFn: () => experienceMasterDataApi.getPremades("important-information", { language_code: "en" }),
    select: ({ data }) => data,
  });
}
